/* globals $shell */
import * as dompack from 'dompack';
import { Class, Events, Options } from "@webhare-system/frameworks/mootools/core";
const $todd = require("./support");
const dombusy = require('dompack/src/busy');
const getTid = require("@webhare-tollium/gettid").getTid;
const focusZones = require('../components/focuszones');
const preload = require('@webhare-system/compat/preload');
const deviceinfo = require('@webhare-system/compat/deviceinfo');
const utilerror = require('@webhare-system/wh/errorreporting');
const Promise = require('@webhare-system/compat/promise');
const WHBase = require('@webhare-system/compat/base');

require("../common.lang.json");

/****************************************************************************************************************************
 *                                                                                                                          *
 *  APPLICATION                                                                                                             *
 *                                                                                                                          *
 ****************************************************************************************************************************/

(function($) { //mootools wrapper
"use strict";

var jsappconstructors = [];

/** Busy lock (while taken, the tollium app is busy
*/
class ApplicationBusyLock extends dombusy.Lock
{
  constructor(app)
  {
    super();
    this.app = app;
  }
  release()
  {
    super.release();
    this.app.removeBusyLock(this);
  }
}

//ADDME: Move these to SessionManager? A SessionManager would manage one user's session in a browser; the CommHandler
//       would manage one or more SessionManagers.

$todd.Application = new Class(
{ Implements: [Events, Options]

, options: { onappbar: true
           , fixedonappbar: false
           }

, container: null
  /// Name of app
, appname: ''
, appicon: ''
, visible: false
  /// Target
, apptarget: {}
  /// Parent application
, parentapp: null
, shell: null
, tabmodifier: ''

/// User config
/// @{

, lang: ''
, dateformat: ''
, timeformat: ''

///@}

/* the screenstack contains the screens currently displayed by this application (including foreign screens) in displayorder.
  screenstack.getLast() is the currently active and only enabled screen */
, screenstack: []
/* the screenmap contains the screens owned by this application (never includes foreign windows) */
, screenmap: {}

///@}

, appisbusy:false
, appisclosing:false
, screencounter: 0
, hasissues:false
, isdebugged:false
, appmenu: []

, busylocks: []
, busysuppressors: {}

  /// Busy lock for application initialization
, initbusylock: null
  /// Keep this app at the bottom of the application stack
, onappstackbottom: false

  // ---------------------------------------------------------------------------
  //
  // Initialization
  //

, initialize: function(shell, appname, apptarget, parentapp, options)
  {
    this.shell = shell;
    if(options)
    {
      this.container = options.container;
      options.container = null;
    }

    if(!this.container)
      this.container = $('desktop');

    this.setOptions(options);
    this.appname = appname;
    this.apptarget = apptarget || {};
    this.title = getTid("tollium:shell.loadingapp");

    this.appnodes = { root: dompack.create('div', { className:"appcanvas wh-focuszone"})
                    , appmodalitylayer: dompack.create('div', { className:"appmodalitylayer"
                                                              , childNodes: [ dompack.create("div", {className:"loader"}) ]
                                                            })
                    };
    this.appnodes.root.appendChild(this.appnodes.appmodalitylayer);
    this.appnodes.root.set("todd-appname", appname);

    this.container.appendChild(this.appnodes.root);

    if(parentapp)
    {
      this.parentapp = parentapp;
      this.options.onappbar=false;
    }

    this.setOnAppBar(this.options.onappbar, this.options.fixedonappbar);

    if(!parentapp)
      this.setVisible(true);

    if ($todd.IsDebugTypeEnabled('ui')) // Show busy locks when clicking on modality layer
      this.appnodes.appmodalitylayer.addEvent('click', this.showBusyFlags.bind(this));
  }

, destroy: function()
  {
    if(this.appnodes)
    {
      this.appnodes.root.destroy();
      this.appnodes.appmodalitylayer.destroy();
    }
  }

, resetApp:async function()
  {
    let shutdownlock = this.getBusyLock();

    if (this.closebusylock)
      this.closebusylock.release();

    Object.keys(this.screenmap).forEach(screenname => this.screenmap[screenname].terminateScreen());

    if (this.appcomm)
    {
      // Close busy locks for sync messages - FIXME dangerous, calls should be rejectable promises and that should clear the locks
      this.eventcallbacks.each(e => { if (e.busylock) e.busylock.release(); if (e.callback) e.callback(); });
      this.eventcallbacks.empty();
      this.queuedEvents.empty();

      // Terminate the app
      if (this.appcomm)
        await this.queueEventAsync('$terminate', '');
      if (this.appcomm)
        this.appcomm.unregister();
      this.appcomm = null;
      this.whsid = null;
    }
    shutdownlock.release();
  }

  // ---------------------------------------------------------------------------
  //
  // Helper stuff: busy indication
  //

, getAppCanvas: function()
  {
    return this.appnodes.root;
  }

, removeBusyLock: function(lock)
  {
    let pos = this.busylocks.indexOf(lock);
    this.busylocks.splice(pos,1);

    $todd.DebugTypedLog("messages", "Busy lock released, now " + this.busylocks.length + " locks active");
    if(this.busylocks.length != 0) //still something up
      return;

//    this.setBusyFlag(Object.getLength(this.busylocks) && !Object.getLength(this.busysuppressors), false);

    // Are we still waiting for the busy indicator to show (short wait period)
    if (this.appbusytimeout)
    {
      // Indicator hasn't been shown yet, nothing to do
      clearTimeout(this.appbusytimeout);
      this.appbusytimeout = null;
    }
    else
    {
      // Indicator is being shown at the moment. Show done indicator
      this.appnodes.root.classList.add('isbusydone');

      // Remove everything after a small delay
      this.appunbusytimeout = this.undisplayBusy.bind(this).delay($todd.Application.busydonedelay);
    }

    // Remove the modality layer immediately
    this.appnodes.root.classList.remove('isbusy');
  }

, showBusyFlags: function()
  {
    console.log('Current busy locks:');
    window.$dompack$busylockmanager.logLocks();
  }

, displayBusy:function()
  {
    this.appnodes.root.classList.add("isbusyindicator");
    this.appbusytimeout = null;
  }

, undisplayBusy:function()
  {
    this.appnodes.root.classList.remove("isbusyindicator");
    this.appnodes.root.classList.remove("isbusydone");
    this.appunbusytimeout = null;
  }

  // ---------------------------------------------------------------------------
  //
  // Embedded application API: Base application functions
  //

, isBusy:function()
  {
    return this.appnodes.root.classList.contains('isbusy');
  }

  /// Load the requested component types, invoke 'callback' when they are loaded
, requireComponentTypes:function(requiredtypes, callback)
  {
    var unloaded_components = $shell.checkComponentsLoaded(requiredtypes, callback);
    if(unloaded_components.length)
      return;
    callback();
  }

, promiseComponentTypes:function(requiredtypes)
  {
    return new Promise(function(resolve, reject)
    {
      this.requireComponentTypes(requiredtypes, resolve);
    }.bind(this));
  }

  /// request a graceful close
, requestClose:function()
  {
    if(this.screenstack.length != 1) //modal dialog open
      return;
    this.screenstack[0].requestClose();
  }

  // ---------------------------------------------------------------------------
  //
  // Embedded application API: Application state management
  //

  /** Acquires a busy lock, returns the lock object. Can be closed with .close(). The application
      is busy until all busy locks are closed
  */
, getBusyLock: function()
  {
    let lock = new ApplicationBusyLock(this);
    this.busylocks.push(lock);

    if(this.busylocks.length > 1) //app already busy
      return lock;

    // Apply the modality layer
    this.appnodes.root.classList.add('isbusy'); //initially this just applies a modality layer

    // FIXME: calculate from real animation periods
    var animation_period_lcm = 6000;

    // Emulate that the animation is running continuously
    var loader = this.appnodes.root.getElement(".loader");
    if (loader)
      loader.style.animationDelay = -(Date.now() % animation_period_lcm) + "ms";

    // Still showing busy indicators? Hide them immediately.
    if (this.appunbusytimeout)
    {
      clearTimeout(this.appunbusytimeout);
      this.undisplayBusy();
    }

    this.appbusytimeout = setTimeout( () => this.displayBusy(), $todd.Application.busyinitialwait);
    return lock;
  }

, setVisible:function(newvisible)
  {
    if(this.visible == newvisible)
      return;

    this.visible=newvisible;
    //this.appnodes.root.setStyle("visibility", this.visible ? "visible" : "hidden");

    if(!this.visible)
    {
      if(this == $todd.applicationstack.getLast()) //we're the currently selected app
      {
        if($todd.applicationstack.length >= 2)
          $todd.applicationstack[$todd.applicationstack.length-2].activateApp();
      }
      $todd.applicationstack.erase(this);
      this.shell.fireEvent("applicationstackchange");
    }
  }
, setOnAppBar:function(onappbar, fixedonappbar)
  {
    if($todd.applicationBar)
      $todd.applicationBar.toggleShortcut(this, onappbar, fixedonappbar);
  }

, updateApplicationProperties:function(props)
  {
    this.appicon = props.appicon;
    this.appiconwidth = props.appiconwidth || 16;
    this.appiconheight = props.appiconheight || 16;
    this.tabmodifier = props.tabmodifier || '';
    this.setAppTitle(props.title);
    this.fireEvent("updateapp");
  }

, createScreen:function(messages)
  {
    //create a new screen
    var name = 'localwin' + (++this.screencounter);
    return this.createNewScreenObject(name, $todd.componentsToMessages(messages));
  }

  // ---------------------------------------------------------------------------
  //
  // Application state
  //

, activateApp: function()
  {
    if($todd.applicationstack.getLast() != this)
    {
      if($todd.applicationstack.getLast())
      {
        //deactivate current application
        $todd.applicationstack.getLast().appnodes.root.classList.remove('visible');
      }

      //move us to the end
      $todd.applicationstack.erase(this);
      $todd.applicationstack.push(this);

      //if the previous app desired to be on the top, move it there. this keeps the dashboard from activating when closing one of multiple open apps
      if($todd.applicationstack.length >= 3 && $todd.applicationstack[$todd.applicationstack.length-2].onappstackbottom)
      {
        $todd.applicationstack.unshift($todd.applicationstack[$todd.applicationstack.length-2]);
        $todd.applicationstack.splice($todd.applicationstack.length-2,1);
      }

      this.shell.fireEvent("activateapp", { app: this });

      //activate
      this.appnodes.root.classList.add('visible');

      if($todd.applicationBar && this.apptab)
        $todd.applicationBar.setActiveShortcut(this.apptab);
      this.setAppTitle(this.title);
      this.shell.fireEvent("applicationstackchange");
    }

    if(this.screenstack.getLast())
      this.screenstack.getLast().focus();
    else
      focusZones.focusZone(this.appnodes.root);
  }

  //terminate an application, clearing all its screens (ADDME: what if we're hosting foreign screens?)
, terminateApplication: function()
  {
    this.setOnAppBar(false); //first leave the appbar, so 'reopen last app' in setVisible doesn't target us
    this.setVisible(false);

    $todd.applications.erase(this);
    return this.resetApp().finally( () =>
    {
      this.destroy(); //FIXME dispose comm channels etc?
      this.fireEvent('ended', {target:this});
      $shell.fireEvent('applicationended', {target:this});
    });
  }

, flashApp: function()
  {
    var win = this.screenstack.getLast();
    if (win)
      win.flashWindow();
  }
, getToplevelApp:function()
  {
    for(var app = this; app.parentapp; app = app.parentapp)
      ;
    return app;
  }
, createNewScreenObject: function(windowname, messages)
  {
    var screen = new $todd.Screen(this,
                                  { window: windowname
                                  , target:'frame'
                                  , specials:[]
                                  }, null);
    this.screenmap[windowname]=screen;
    if(messages)
      screen.processMessages(messages);

    var showapp = this.getToplevelApp();
    showapp.appnodes.root.appendChild(screen.getNode());
    screen.showScreen(showapp);

    return screen;
  }

  // ---------------------------------------------------------------------------
  //
  // Application settings
  //

, setAppTitle: function(newtitle)
  {
    this.title = newtitle;
    if ($todd.applicationstack.getLast() == this)
    {
      let prefix = $shell.getCurrentSettings().browsertitleprefix;
      document.title = (prefix ? prefix + ' ' : '') + this.title;
    }
  }

  // ---------------------------------------------------------------------------
  //
  // Application menu
  //

, generateAppMenu: function()
  {
    return this.appmenu.slice(0);
  }

, executeCommand: function(cmd)
  {
    //unknown, pass it to the shell
    this.shell.executeInstruction(cmd);
  }

  // ---------------------------------------------------------------------------
  //
  // Screen management
  //

, getScreenByName: function(windowname)
  {
    return this.screenmap[windowname];
  }

  // ---------------------------------------------------------------------------
  //
  // Message processors
  //

, onMsgGetNotificationPermissionState: function()
  {
    // This function is called in a context the state may change, so let towl check too
    $todd.towl.updateForCurrentNotificationPermission();

    return window.Notification
        ? Notification.permission
        : "";
  }

, onMsgShellReveal:function(path)
  {
    this.shell.executeInstruction({type:'shell:reveal', folder:path});
  }

, onMsgGetWebhareConnectRegisteredInstallations: function()
  {
    return $shell.getWebhareConnectRegisteredInstallations();
  }

  // ---------------------------------------------------------------------------
  //
  // Dialogs
  //

  /** Creates a dialog informing the user an exception took place, and reports the exception to the backend.
      @long This function can be used to place in a promise catch handler. It opens a messagebox informing
         the user an error took place, and reports that error to the backend. It is bound to the application,
         no rebinding necessary.
      @param e Exception object
      @example
      (*operation returning a promise*).catch(app.showExceptionDialog)
  */
, showExceptionDialog: function(e)
  {
    utilerror.reportException(e);
    $todd.createMessageBox(this,
          { text: getTid("tollium:shell.errors.errortitle")
          , buttons: [{ name: 'close', title: getTid("tollium:common.actions.close") }]
          }).catch(utilerror.reportException);
  }


});

$todd.Application.busyinitialwait=200;  //time before we show a loader
$todd.Application.busydonedelay=50;     //time before we start the 'done' fadeout

//An embedded application 'lives' in the tollium javascript. We better trust it...
$todd.FrontendEmbeddedApplication = new Class(
{ Extends: $todd.Application
, initialize: function(shell, appname, apptarget, parentapp, options)
  {
    this.parent(shell, appname, apptarget, parentapp, options);
  }
, loadApplication:function(manifest)
  {
    this.baseobject = manifest.baseobject;

    if(!jsappconstructors[this.baseobject])
    {
      let scr = $todd.FrontendEmbeddedApplication.scripts[manifest.baseobject];
      if(!scr)
      {
        scr = preload.promiseScript(manifest.src + "?__cd=" + Date.now());
        $todd.FrontendEmbeddedApplication.scripts[manifest.baseobject] = scr;
      }
      scr.then(result => this.onAppLoadComplete({success:true}));
    }
    else
    {
      this.onAppLoadComplete({success:true});
    }
  }
, onAppLoadComplete:function(event)
  {
    if(event.success && jsappconstructors[this.baseobject])
    {
      this.app = new jsappconstructors[this.baseobject](this, this.onAppInitComplete.bind(this));
      return;
    }

    console.error("Failed to load application " + this.baseobject); //FIXME how to deal with it?
    console.log(event);
  }
, onAppInitComplete:function(event)
  {
    this.fireEvent('load', { target: this });
  }
, queueEvent:function(actionname, param, synchronous, callback)
  {
    console.warn("Cannot handle event '" + actionname + "'",param);
  }
, queueUnloadMessage: function()
  {
    // No action needed in frontend apps
  }
});

$todd.FrontendEmbeddedApplication.scripts=[];

$todd.BackendApplication = new Class(
{ Extends: $todd.Application
  // ---------------------------------------------------------------------------
  //
  // Variables
  //

  /// Application metadata and communication
  /// @{

  /// Application id
, whsid: ''


  /// Frontend id used for this application
, frontendid: ''

  /// Host for communication with backend
, commhost: ''

  /// Communication endpoint
, appcomm: null

, lastinitmessage: 0

, startoptions: {}
, eventcallbacks: [] //seqnr (sorted), callback

, deferred_close: null
, deferred_metamessage: null

, queuedEvents: []

, closebusylock: null

  ///@}


, initialize: function(shell, appname, apptarget, parentapp, options)
  {
    this.parent(shell, appname, apptarget, parentapp, options);
  }

, applyAppInit: function(node)
  {
    this.whsid = node.whsid;
    this.commhost = node.commhost;
    this.lang = node.lang;
    if (this.lang)
      $todd.fallback.lang = this.lang;
    this.dateformat = node.dateformat;
    if (this.dateformat)
      $todd.fallback.dateformat = this.dateformat;
    this.timeformat = node.timeformat;
    if (this.timeformat)
      $todd.fallback.timeformat = this.timeformat;

    this.appcomm = new $todd.LinkEndPoint({ linkid: this.whsid, commhost: this.commhost, frontendid: this.frontendid });
    this.appcomm.onmessage = this.processMessage.bind(this);
    this.appcomm.onclosed = this._gotLinkClosed.bind(this);
    this.appcomm.registerManuallyReceivedMessage(this.lastinitmessage);

    this.appcomm.register($todd.transportmgr);

    // Wait for both link close & metamessage to close application
    this.deferred_close = dompack.createDeferred();
    this.deferred_metamessage = dompack.createDeferred();

    this.deferred_close.promise
        .then(function() { return this.deferred_metamessage.promise; }.bind(this)) // wait for metamessage and adopt the value
        .then(this._closeApplication.bind(this));
  }

, handleMetaMessage: function(data)
  {
    switch (data.type)
    {
      case "error":
      {
        if (data.appid != this.whsid)
          return; // this message is for an old app (we've restarted since then)

        if (!this.closebusylock)
          this.closebusylock = this.getBusyLock();

        this.deferred_metamessage.resolve(data);
        this.deferred_close.resolve.delay(5000); // wait max 5 secs for link close

        this.appisclosing = true;
      } break;

      case "debugstatus":
      {
        this.isdebugged = data.attached;
        this.fireEvent("updateapp");
      } break;
    }
  }

, handleMetaClose: function()
  {
    this.deferred_metamessage.resolve(null);
    this.deferred_close.resolve.delay(5000); // wait max 5 secs for link close
  }

, start: function(frontendid)
  {
    this.frontendid = frontendid;
  }

, restart: function()
  {
    let restartlock = this.getBusyLock();
    return this.resetApp().then( () =>
    {
      this.launchApp(true);
      restartlock.release();
    });
  }

/****************************************************************************************************************************
 * Communications
 */

, queueEventAsync: function(actionname, param)
  {
    return new Promise( (resolve, reject) =>
    {
      this.queueEvent(actionname, param, true, reply => resolve(reply));
    });
  }

, queueEvent: function(actionname, param, synchronous, callback)
  {
    if (!synchronous && callback)
      throw new Error("Callbacks are not allowed for asynchronous messages");

    if (!this.appcomm)
      console.error("Trying to send event after the application link closed: ", actionname, param);

    this.queuedEvents.push(
        { actionname:   actionname
        , param:        param
        , synchronous:  synchronous
        , callback:     callback
        , busylock:     synchronous ? this.getBusyLock() : new dombusy.Lock
        });

    this._sendQueuedEvents();
  }

, _sendQueuedEvents: function()
  {
    if (this.eventcallbacks.length != 0)
    {
      if (this.queuedEvents.length)
        console.log('Deferring sending queued events, still outstanding sync events');
      return;
    }

    if (!this.appcomm) // Not shut down already?
      return;

    var sentforms = false;
    while (this.queuedEvents.length)
    {
      var event = this.queuedEvents.shift();

      var response = { action:  event.actionname
                     , param:   event.param || ''
                     , forms:   []
                     , requirereply: true
                     };

      // Send forms only once per run of events
      if (!sentforms)
      {
        response.forms = Object.keys(this.screenmap).map(key => ({ name:key, fields:this.screenmap[key].getSubmitVariables() }));
        sentforms = true;
      }

      if($todd.IsDebugTypeEnabled('rpc'))
      {
        console.group("RPC log - outgoing. " + (response.requirereply?'sync':'async') + ", action: "+(event.actionname||'n/a')+', param:', event.param || '');
        for (var i=0;i<response.forms.length;++i)
        {
          console.group("form " + response.forms[i].name);
          Object.keys(response.forms[i].fields, key => console.log('comp ' + key+' value: ', response.forms[i].fields[key]));
          console.groupEnd();
        }
        console.groupEnd();
      }

      var seqnr = this.appcomm.queueMessage(response);
      this.eventcallbacks.push({ seqnr: seqnr, busylock: event.busylock, callback: event.callback });

      // Issue max 1 synchronous event at a time
      if (event.synchronous)
        break;
    }
  }

, applyReceivedReplies: function(replies)
  {
    var busylocks = [];

    // Execute callbacks for the events, and remove them from the callbacks array
    replies.forEach(reply =>
    {
      $todd.DebugTypedLog("messages", 'got reply for ', reply.seqnr);
      let pos = this.eventcallbacks.findIndex(callback => callback.seqnr == reply.seqnr);
      if (pos >= 0)
      {
        let rec = this.eventcallbacks.splice(pos, 1)[0];
        if (rec.callback)
          rec.callback(reply.replydata);
        busylocks.push(rec.busylock);
      }
    });

    this._sendQueuedEvents();

    busylocks.forEach(lock => lock.release());
  }

, handleMessage: function(msgrec)
  {
    switch (msgrec.type)
    {
    case 'response':
      {
        this.processMessage(msgrec.response);
      } break;
    default:
      {
        console.error('Unrecognized message type ', msgrec.type, msgrec);
      }
    }
  }

, getRequiredComponentTypes:function(msg)
  {
    var types=[];
    msg.screens.each(function(screen)
      {
        screen.messages.each(function(screenmsg)
          {
            if(screenmsg.instr=='component')
            {
              types.include(screenmsg.type);
            }
          });
      });
    return types;
  }

, processMessage: function(msg)
  {
    if($todd.IsDebugTypeEnabled('rpc'))
    {
      console.group("RPC log - incoming");
      console.log(msg);
      msg.instructions.each(function(instr)
        {
          console.log(instr.instr, instr);
        });

      msg.screens.each(function(screenupdate,idx)
        {
          console.log("Screen #" + idx + ": " + screenupdate.name);
          screenupdate.messages.each(function(screenmsg,idx)
            {
              console.log(idx,screenupdate.name + ':' + screenmsg.target,screenmsg.instr,screenmsg);
            });
        });
      console.groupEnd();
    }
    this.requireComponentTypes(this.getRequiredComponentTypes(msg), this.handleResponse.bind(this, msg));
  }

, handleResponse: function(response)
  {
    var grabactivation = 0;

    // Id of formstate to send (0 is don't send), and whether to send synchronously
    var sendformstate = 0;
    var sendformstatesync = false;

    var isappinit = false;

    //ADDME Instead of a list of instructions, the server should simply transfer one JSON object, ready to reprocess
    var pendingreplies = [];

    response.instructions.each(function(instr)
      {
        var instrname = instr.instr;

        if(instrname == "sendappmessage")
          this.applyXMLLaunch(instr);
        else if(instrname == "reply")
          pendingreplies.push(instr);
        else if(instrname == "appdebuginfo")
        {
          instr.msg.split('\n').each(function(line) { console.log("APP:"+line); });
        }
        else if(instrname == "init")
        {
          isappinit=true;
          this.applyAppInit(instr);
        }
        else if(instrname == "appupdate")
        {
          this.applyAppUpdate(instr);
        }
        else if(instrname == "grabactivation")
        {
          grabactivation=1;
        }
        else if(instrname == "redirect")
        {
          if($wh.config.tollium.frontendmode)
            window.parent.location.href = instr.url;
          else
            console.warn("Ignoring redirection instruction, they are only accepted in frontend mode");
        }
        else if (instrname == "sendformstate")
        {
          if (sendformstate < instr.id)
            sendformstate = instr.id;
          sendformstatesync = sendformstatesync || instr.sync;
        }
        else if (instrname == "appcall")
        {
          this._executeAppCall(instr);
        }
        else
        {
          console.error("Unknown instruction '" + instrname + "' received");
        }
      }.bind(this));

    Array.each(response.screens, function(screen)
      {
        var scr = this.getScreenByName(screen.name);
        if(scr)
          scr.processMessages(screen.messages);
        else
          this.createNewScreenObject(screen.name, screen.messages);
      }.bind(this));

    //Screens had a chance to process and request new locks, now we can release any locks associated with the original replies
    this.applyReceivedReplies(pendingreplies);

    if(grabactivation)
      this.activateApp();

    if(isappinit)
    {
      this.fireEvent('load', { target: this });
    }

    if (sendformstate)
    {
      // Server requested form state. Send asynchronously
      this.queueEvent('$formstate', sendformstate, sendformstatesync, null);
    }
  }

, _executeAppCall: function(instr)
  {
    Promise.resolve(true).then(function()
    {
      if (this["onMsg" + instr.type])
        return this["onMsg" + instr.type].apply(this, instr.params);
      throw new Error("No such app call type '" + instr.type + "'");
    }.bind(this)).then(function(result)
    {
      this.queueEvent("$controllermessage", { type: "clientcallreply", id: instr.id, resolve: true, result: result === undefined ? null : result});
    }.bind(this), function (error)
    {
      this.queueEvent("$controllermessage", { type: "clientcallreply", id: instr.id, resolve: false, result: error.stack || error + "" });
    }.bind(this));
  }

, _gotLinkClosed: function()
  {
    this.appcomm = null;
    if (!this.closebusylock)
      this.closebusylock = this.getBusyLock();

    // Remove event callbacks and queued events, won't be activated again
    this.eventcallbacks.forEach(e => { if (e.busylock) e.busylock.release(); if (e.callback) e.callback(); });
    this.eventcallbacks.empty();
    this.queuedEvents.forEach(e => { if (e.busylock) e.busylock.release(); if (e.callback) e.callback(); });
    this.queuedEvents.empty();

    this.deferred_close.resolve(); // wait max 5 secs for official close
    this.deferred_metamessage.resolve.bind(null, null).delay(5000);
  }

, _closeApplication: function(metamessage)
  {
    // Remove the 'closing' busy lock
    if (this.closebusylock)
    {
      this.closebusylock.release();
      this.closebusylock = null;
    }

    // Won't be referred by our whsid anymore
    this.whsid = null;

    if (!metamessage || !metamessage.errors.length)
    {
      //It's just telling us our parent app has terminated. ADDME if we get no errors, but there are still screens open, there's still an issue!
      this.terminateApplication();
      return;
    }

    $todd.handleApplicationErrors(this, metamessage);
  }

/****************************************************************************************************************************
* Application updates
*/
, generateAppMenu: function()
  {
    var appmenu = this.parent();
    appmenu.unshift({ title: getTid('tollium:shell.restartapp'), cmd: { type : "currentapp:restart" } });
    return appmenu;
  }

, executeCommand: function(cmd)
  {
    switch(cmd.type)
    {
      case 'currentapp:restart':
        this.restart();
        break;
      case 'currentapp:controllermsg':
        this.queueEvent("$controllermessage", cmd.msg, true);
        break;
      default:
        this.parent(cmd);
        break;
    }
  }

, applyAppUpdate: function(node)
  {
    switch(node.type)
    {
      case 'language':
        if (node.lang)
        {
          this.lang = node.lang;
          $todd.fallback.lang = this.lang;
        }
        if (node.dateformat)
        {
          this.dateformat = node.dateformat;
          $todd.fallback.dateformat = this.dateformat;
        }
        if (node.timeformat)
        {
          this.timeformat = node.timeformat;
          $todd.fallback.timeformat = this.timeformat;
        }
        return;

      case 'target':
        this.apptarget = node.target;
        return;

      case 'apptab':
        this.hasissues = node.hasissues;
        this.appmenu = node.appmenu;
        this.isdebugged = false;
        this.updateApplicationProperties( { title: node.title
                                          , appicon: node.icon
                                          });
        return;

      case "closescreen":
        var scr = this.getScreenByName(node.screen);
        if(!scr)
          console.error("App '" + this.appname + "' received close instruction for non-existing screen '" + node.screen + "'"); //ADDME test on harescript level - RunDialog with closing onshow? is this even reachable ?
        else
          scr.terminateScreen();
        return;

      case "callurl":
        var newwindow = window.open(node.url, node.target || "_blank");
        if (newwindow && newwindow.focus)
          try { newwindow.focus(); } catch (e) { console.log('New window focus failed: ' + e); }
        return;
    }
    console.error('Unexpected application update type: ' +node.type);
  }

, applyXMLLaunch: function(node)
  {
    console.log('applyXMLLaunch', node);
    this.shell.sendApplicationMessage(node.app, node.target, node.message, node.reuse);
  }
, launchApp:function(restart)
  {
    let initlock = this.getBusyLock();
    return new Promise( (resolve,reject) =>
    {
      this.shell.tolliumservice.request('StartApplication',
            [ this.appname
            , this.options
            , deviceinfo.getInfo()
            , this.shell.getWebHareConnectData()
            ], data =>
               {
                 this.gotApplication(data);
                 initlock.release();
                 resolve(data);
               }
             , err =>
               {
                 this.failApplication(err);
                 initlock.release();
                 reject(err);
               });
    });
  }
, gotApplication: function(data)
  {
    //ADDME dealing with subapps?

    //destroy any screens - FIXME why??

    if (data.status != 'ok')
    {
      this.setAppTitle('Application');
      this.fireEvent("updateapp");
      $todd.handleApplicationErrors(this, data);
      return;
    }

    this.shell.registerApplicationFrontendLink(data);

    var appstartmsg = data.appdata;
    if (appstartmsg.type == 'appstart')
    {
      //this.startoptions = options;

      this.start(data.frontendid);

      for (var i = 0; i < appstartmsg.data.messages.length; ++i)
      {
        this.lastinitmessage = appstartmsg.data.messages[i].seqnr;
        this.handleMessage(appstartmsg.data.messages[i].data);
      }
    }
  }

, failApplication: function(data)
  {
    console.warn("Unable to contact the application launch service. The application server may need a 'soft-reset'");
    console.log(data);
    alert("Unable to contact the application server."); //FIXME what to tell a user, really?
  }



/****************************************************************************************************************************
 * Other stuff
 */

, queueUnloadMessage: function()
  {
    //no point in marking us synchronous, we may yet be reloaded
    //FIXME more robust unload mechanism - use a centrale queue and beacon ?
    this.queueEvent('$terminate', '', false, null);
  }

});


/****************************************************************************************************************************
 * Global application functions
 */

$todd.frontendids = [];

$todd.getActiveApplication = function()
{
  return $todd.applicationstack.getLast();
};

$todd.registerJSApp = function(name, constructor)
{
  jsappconstructors[name]=constructor;
};

})(document.id); //end mootools wrapper



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/application.es